import { trace } from 'rytm-helpers'
import Sound from '../models/Sound'


class SoundBankController {
  /**
  * SoundBankController class constructor  
  * @constructor
  **/
  constructor() {
    this.id = null
    this.sounds = {}
    this.soundIds = []
    this.pan = 0
  }
  /**
   * Add sound bank
   * @param {Array} files 
   * @param {String} path 
   */
  addSoundBank(sndBank) {
    trace("init sound bank", sndBank.id)
    this.id = sndBank.id
    sndBank.sounds.forEach((file) => {
      const snd = new Sound(file, sndBank.path + file)
      this.sounds[snd.id] = snd
      this.soundIds.push(snd.id)
    })
  }
  /**
   * Destroy sound bank
   */
  destroySoundBank() {
    this.soundIds.forEach((id) => {
      this.sounds[id].destroy()
    })
    this.sounds = []
    this.soundIds = []
    this.id = null
    this.pan = 0
  }
  /**
   * Play sound by ID
   * @param {String} sndId 
   */
  playSound(sndId, params) {
    if (this.sounds[sndId]) {
      params.pan = this.pan
      this.sounds[sndId].play(params)
    } else {
      console.warn("Can't find sound:", sndId)
    }
  }
  getSoundFrequencyData(sndId) {
    if (this.sounds[sndId]) {
      return this.sounds[sndId].getFrequencyData()
    } else {
      console.warn("Can't find sound:", sndId)
    }
  }
  /**
   * 
   */
  stopAllSounds() {
    this.soundIds.forEach((id) => {
      this.sounds[id].stop()
    })
  }
  /**
   * Get random sound ID
   */
  getRandomSoundId() {
    return this.soundIds[Math.floor(Math.random() * this.soundIds.length)];
  }
  /**
   * get random sound ID for letter
   * @param {String} letter 
   */
  getRandomSoundIdForLetter(letter) {
    let id = null
    let list = this.getAllSoundIdsForLetter(letter)
    if (list.length > 0) {
      id = list[Math.floor(Math.random() * list.length)];
    }
    return id
  }
  /**
   * get random sound ID for letter
   * @param {String} letter 
   */
  getAllSoundIdsForLetter(letter) {
    let arr = []
    this.soundIds.forEach((id) => {
      if (id.charAt(0) == letter) {
        arr.push(id)
      }
    })
    return arr
  }
  
  /**
   * get sequence random time for sound
   */
  getSequenceRandomTimeForSnd(sndId) {
    let time = 100;
    if (this.sounds[sndId]) {
      time = this.sounds[sndId].getSequenceRandomTime()
    } else {
      console.warn("Can't find sound:", sndId)
    }
    return time
  }
  

}

export default SoundBankController;
